import React from 'react';

export default function WolfEarsSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      <polygon points="14.71,21.16 7.01,21.16 7.6,16.72 15.3,16.72" fill="#85829A" />
      <polygon points="11.48,25.75 2.0,21.83 7.89,7.61 17.37,11.53" fill="#85829A" />
      <polygon points="38.0,21.83 28.52,25.75 22.63,11.53 32.11,7.61" fill="#85829A" />
      <polygon points="31.93,22.19 24.23,22.19 24.82,17.74 32.52,17.74" fill="#85829A" />
      <polygon points="12.05,24.67 7.31,22.7 12.22,10.85 16.96,12.82" fill="#85829A" />
      <polygon points="7.31,22.7 6.54,22.32 11.45,10.47 12.22,10.85" fill="#535164" opacity="0.95" />
      <polygon points="34.23,22.7 29.49,24.67 24.58,12.82 29.32,10.85" fill="#85829A" />
      <polygon points="29.49,24.67 34.23,22.7 33.46,22.32 28.72,24.28" fill="#535164" opacity="0.95" />
      <polygon points="29.49,24.67 28.72,24.28 23.81,12.43 24.58,12.82" fill="#535164" opacity="0.95" />
      <polygon points="31.4,24.7 10.87,24.7 10.87,22.13 31.4,22.13" fill="#85829A" />
      <polygon points="10.87,24.7 31.4,24.7 29.86,23.93 9.33,23.93" fill="#535164" opacity="0.95" />
      <polygon points="10.87,24.7 9.33,23.93 9.33,21.36 10.87,22.13" fill="#535164" opacity="0.95" />
      <polygon points="33.96,32.39 31.4,32.39 31.4,22.13 33.96,22.13" fill="#85829A" />
      <polygon points="31.4,32.39 33.96,32.39 32.42,31.62 29.86,31.62" fill="#535164" opacity="0.95" />
      <polygon points="31.4,32.39 29.86,31.62 29.86,21.36 31.4,22.13" fill="#535164" opacity="0.95" />
      <polygon points="10.87,32.39 8.31,32.39 8.31,22.13 10.87,22.13" fill="#85829A" />
      <polygon points="8.31,32.39 10.87,32.39 9.33,31.62 6.77,31.62" fill="#535164" opacity="0.95" />
      <polygon points="8.31,32.39 6.77,31.62 6.77,21.36 8.31,22.13" fill="#535164" opacity="0.95" />
    </svg>
  );
}
